module.exports = __webpack_public_path__ + "img/six.cba70b69.png";